module.exports = __webpack_public_path__ + "media/digital/Digitization-4581102e.png";